import Insight from "../insightClass";
import React from "react";
import { insight113Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight113 = new Insight(
  "18 May 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight113Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly (2026-05-18)",
  "",
  `RWE and Masdar have secured Development Consent Orders for the 3GW Dogger Bank South offshore wind projects, clearing one of the most important permitting hurdles for the UK’s next generation of large-scale North Sea assets. The two projects, Dogger Bank South East and Dogger Bank South West, are located more than 100km off northeast England and each has a planned capacity of 1.5GW.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-05-18)</h1>
    <h2></h2>
    <p className="article-date">18 May 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. RWE and Masdar secure UK consent for 3GW Dogger Bank South</h3>
    <p>
      RWE and Masdar have secured Development Consent Orders for the 3GW Dogger
      Bank South offshore wind projects, clearing one of the most important
      permitting hurdles for the UK’s next generation of large-scale North Sea
      assets. The two projects, Dogger Bank South East and Dogger Bank South
      West, are located more than 100km off northeast England and each has a
      planned capacity of 1.5GW.
    </p>
    <p>
      The projects had already secured Contracts for Difference earlier this
      year, meaning the latest consent decision strengthens their route from
      award to delivery. RWE has indicated that the projects are now moving into
      final design and towards final investment decision. First power is
      targeted for 2030, with full commissioning expected in 2031–32.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This is one of the clearest signals that the UK offshore wind market is
      moving from auction recovery into delivery mode. After several years of
      inflation, supply-chain pressure and uncertainty around auction pricing,
      the market is now being tested on whether consented and contracted
      projects can actually reach final investment decision and construction.
    </p>
    <p>
      Dogger Bank South is also strategically important because it sits
      alongside other major North Sea developments that will shape the UK’s 2030
      clean power ambition. For developers and investors, the key point is not
      only capacity size, but sequencing: consent, CfD support, design
      finalisation, supply-chain contracting and grid connection must now align.
    </p>
    <p>
      The commercial opportunity is significant, but execution risk remains
      high. Large projects of this scale will require strong coordination across
      foundations, cables, ports, vessels, grid infrastructure and financing.
      For the UK supply chain, Dogger Bank South could provide a multi-year
      project pipeline, but only if procurement structures create space for
      local capability rather than relying entirely on global bottleneck
      suppliers.
    </p>
    <h3>2. First monopile installed at Hornsea 3 offshore wind farm</h3>
    <p>
      The first of 197 monopiles has been installed at the Hornsea 3 offshore
      wind farm site, around 120km off the coast of Norfolk. The 2.9GW project,
      developed by Ørsted, is expected to be the world’s largest single offshore
      wind farm once completed.
    </p>
    <p>
      Hornsea 3 will use 197 Siemens Gamesa SG 14-236 DD offshore wind turbines,
      each with a capacity of 14MW excluding power boost. The foundation
      installation milestone marks the start of a major offshore construction
      phase and reflects the increasing scale and complexity of UK fixed-bottom
      offshore wind projects.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Hornsea 3 is more than another large UK offshore wind farm. It is a
      benchmark project for how the industry handles next-generation scale. With
      197 foundations and 2.9GW of capacity, the project requires industrialised
      execution, vessel availability, port coordination, precision logistics and
      strong supplier performance.
    </p>
    <p>
      For the UK, Hornsea 3 is strategically important because it helps bridge
      the gap between existing operational capacity and the scale required for
      2030 decarbonisation targets. It also demonstrates that very large
      projects can continue progressing despite the difficult cost environment
      that has challenged offshore wind globally.
    </p>
    <p>
      However, scale alone does not remove risk. Larger turbines, larger
      monopiles and larger project packages increase dependency on a smaller
      pool of capable suppliers. Any delay in vessel scheduling, component
      delivery, weather windows or grid readiness can have wider consequences.
      Hornsea 3 will therefore be watched closely not just as a generation
      asset, but as a test of whether the offshore wind construction model can
      remain reliable at multi-gigawatt scale.
    </p>
    <h3>3. UK offshore wind pipeline reaches 93GW</h3>
    <p>
      The UK offshore wind pipeline has reached 93GW across operational, planned
      and potential projects, according to the latest market update. This figure
      underlines the UK’s continued position as one of the world’s most
      important offshore wind markets, even as the sector faces pressure from
      consenting timelines, grid readiness, supply-chain constraints and auction
      design.
    </p>
    <p>
      The pipeline number is significant because it reflects both existing
      momentum and the scale of delivery still required. It includes projects at
      different stages of maturity, meaning not all capacity should be treated
      as equally bankable or near-term. Nevertheless, the figure confirms that
      the UK still has a deep project base from which to support future clean
      power targets.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      A 93GW pipeline is impressive, but the real question is conversion. The UK
      does not simply need more projects on paper; it needs a higher proportion
      of projects to move from early-stage planning to consent, CfD award, final
      investment decision and construction.
    </p>
    <p>
      For investors, the pipeline shows market depth. For policymakers, it
      highlights the scale of coordination required across seabed leasing, grid
      reinforcement, environmental assessment, port capacity, skills and
      supply-chain investment. For the supply chain, it creates a strong demand
      signal, but suppliers will still look for bankable order visibility before
      committing to new factories, vessels or workforce expansion.
    </p>
    <p>
      The UK’s challenge is now less about ambition and more about system
      delivery. A large pipeline can strengthen investor confidence, but only if
      policy stability, grid connections and revenue support are credible.
      Otherwise, the gap between pipeline capacity and commissioned capacity
      will remain one of the defining risks for the UK offshore wind market.
    </p>
    <h3>
      4. Mubadala invests US$325 million in Hornsea 3 alongside Apollo-led
      consortium
    </h3>
    <p>
      Mubadala Investment Company has announced a US$325 million investment in
      Ørsted’s Hornsea 3 offshore wind farm, investing alongside a consortium
      led by Apollo-managed funds. The consortium also includes USS and La
      Caisse. The investment follows Apollo Funds’ acquisition of a 50% stake in
      the joint venture holding Hornsea 3, with Ørsted retaining the remaining
      50% ownership and continuing to lead development, construction and
      operation.
    </p>
    <p>
      Hornsea 3 is Ørsted’s third gigawatt-scale offshore wind project within
      the Hornsea zone in the North Sea. Once completed, the project is expected
      to deliver 2.9GW of capacity and provide enough renewable electricity to
      power more than 3.3 million UK homes.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This transaction is important because it shows how institutional and
      sovereign capital continues to view large UK offshore wind as a
      long-duration infrastructure asset, even during a period when the sector
      has faced cost inflation and supply-chain pressure.
    </p>
    <p>
      Hornsea 3 combines several characteristics that infrastructure investors
      typically value: scale, location in a mature regulatory market,
      experienced project leadership and long-term relevance to national
      electricity demand. The entry of Mubadala alongside Apollo-managed funds
      also reflects a broader shift in offshore wind financing. As projects
      become larger and more capital-intensive, developers increasingly rely on
      partnership models to share risk, recycle capital and maintain
      balance-sheet flexibility.
    </p>
    <p>
      For Ørsted, retaining 50% ownership while continuing to lead construction
      and operations allows it to preserve strategic control while bringing in
      deep-pocketed financial partners. For the wider market, the deal
      reinforces the role of sovereign and pension-linked capital in funding the
      next wave of offshore wind build-out.
    </p>
    <p>
      The key message is that offshore wind is moving further into the
      mainstream infrastructure investment universe. However, investor appetite
      will continue to depend on disciplined risk allocation, construction
      certainty, stable regulation and credible long-term power market
      fundamentals.
    </p>
    <h3>5. North Falls Offshore Wind Farm granted UK development consent</h3>
    <p>
      The North Falls Offshore Wind Farm has been granted development consent by
      the Department for Energy Security and Net Zero. The project is for an
      offshore electricity generating station located approximately 24.5km from
      its nearest point at the Port of Lowestoft. It is estimated to have an
      installed capacity in excess of 100MW and will principally comprise
      offshore wind turbines and associated onshore and offshore infrastructure,
      including connection to the electricity transmission network.The
      application was submitted to the Planning Inspectorate on 26 July 2024 and
      accepted for examination on 22 August 2024. Following a six-month
      examination process involving the public, statutory consultees and
      interested parties, recommendations were made to the Secretary of State on
      28 October 2025. The decision was announced on 14 May 2026.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      North Falls is smaller in scale than mega-projects such as Hornsea 3 or
      Dogger Bank South, but its consent is still commercially meaningful. The
      UK offshore wind market needs both very large anchor projects and
      medium-sized developments that can add capacity, support regional
      supply-chain activity and make use of existing grid and coastal
      infrastructure.
    </p>
    <p>
      The project’s location near the east coast of England also reinforces the
      importance of the southern North Sea as a continuing offshore wind
      development zone. For communities and local authorities, the six-month
      examination process highlights the growing role of public participation in
      offshore wind consenting. As more projects move through planning, managing
      local concerns around onshore works, grid connection, landfall and
      environmental impacts will remain essential.
    </p>
    <p>
      From a market perspective, the consent decision adds another project to
      the UK’s deliverable pipeline. However, development consent is not the
      same as final investment decision. The project will still need to progress
      through commercial structuring, supply-chain procurement, grid
      coordination and financing. For WeBridge, the main takeaway is that the UK
      consenting system is still moving projects forward, but the industry must
      now turn permissions into investable and buildable assets.
    </p>
    <h3>6. First foundations installed at Poland’s 1.5GW Baltica 2</h3>
    <p>
      Major offshore construction has started at the 1.5GW Baltica 2 offshore
      wind farm in the Polish Baltic Sea. Van Oord has installed the first
      monopile foundations at the project site for the development, which is
      being advanced by Ørsted and PGE Polska Grupa Energetyczna.The monopiles
      are approximately 100 metres long, more than 10 metres in diameter and
      weigh around 1,500 tonnes each. Baltica 2 will feature 107 Siemens Gamesa
      14MW turbines and is scheduled to enter full operation in 2027. The
      project secured a 25-year inflation-protected CfD with the Polish state in
      2021, and the final investment decision was taken in January 2025.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Baltica 2 is a milestone for Poland’s offshore wind ambitions and for the
      wider Baltic Sea market. Poland has long been seen as one of Europe’s most
      important emerging offshore wind markets because of its large
      coal-replacement requirement, industrial base and Baltic resource
      potential.
    </p>
    <p>
      The start of foundation installation is commercially meaningful because it
      moves the project from planning and contracting into visible offshore
      execution. It also demonstrates that Poland’s first large-scale offshore
      wind phase is becoming real infrastructure rather than policy ambition.
    </p>
    <p>
      For supply-chain companies, the Polish market offers a significant
      opportunity, but competition will be shaped by local content expectations,
      port readiness and the ability to integrate Polish manufacturing into
      wider European project delivery. Baltica 2 will therefore be closely
      watched as a reference project for future Polish rounds and for the
      broader question of whether emerging European offshore wind markets can
      build durable domestic supply-chain ecosystems.
    </p>
    <h3>7. Türkiye prepares first offshore wind tender</h3>
    <p>
      Türkiye is preparing to launch its first offshore wind Renewable Energy
      Resource Area tender after completing processes for four identified
      offshore wind sites. The country’s energy minister has described offshore
      wind as one of the most strategic priorities for the coming period and has
      stated a target of reaching 5GW of offshore wind capacity by 2035.Türkiye
      also plans to continue holding YEKA tenders for at least 2GW annually,
      with 1.5GW of the 2026 tender capacity expected to be allocated to wind
      projects. The country is also planning major transmission investment by
      2035 as part of a broader goal to reach 120GW of combined wind and solar
      capacity.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Türkiye’s offshore wind move is important because it shows the expansion
      of the sector beyond Europe’s mature North Sea and Baltic markets. The
      country has strong industrial potential, an established onshore wind
      supply chain and a strategic location between European, Middle Eastern and
      Asian energy markets.
    </p>
    <p>
      However, first tenders are always delicate. Tender design will determine
      whether Türkiye attracts serious international developers or merely
      signals ambition. Key issues will include site data quality, grid
      connection responsibility, currency and inflation risk, local content
      requirements, permitting clarity and bankability of the offtake mechanism.
    </p>
    <p>
      If designed well, Türkiye could become a new offshore wind manufacturing
      and project-development hub, particularly for floating wind in the longer
      term. But if risk allocation is too heavy for developers, early tenders
      could struggle. The most important signal to watch is not only the target
      capacity, but whether the tender framework offers a credible route to
      financeable projects.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
